<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cxcdetcom"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cxcdetcomprobante" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar"
            [botonBorrar]="botonBorrar" [botonRegresar]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="true" [barraBotones5]="true"
            [botonBuscarPermanente]="true"
            ></app-invmaebarra>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <!-- <div class="p-col-1">
                            <span>Número:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="ENCREGCOMPRO_NUMERO"></label>
                            <input class="frm" id="ENCREGCOMPRO_NUMERO" type="text" pInputText disabled [(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_NUMERO"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                        </div> -->
                        <div class="p-col-1">
                            <span>Banco:</span>
                        </div>
                        <div class="p-col-2">
                            <label for="BAN_CODIGO"></label>
                            <input class="frm" id="BAN_CODIGO" type="text" pInputText [disabled]="false"
                                [(ngModel)]="BAN_CODIGO"
                                (keydown.enter)="setFocus($event)" 
                                autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <button type="button"
                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                (click)="busquedabanco(BAN_CODIGO)"></button>
                        </div>
                        <div class="p-col-3">
                            <label for="lblbannombre"></label>
                            <input class="frm" id="lblbannombre" type="text" pInputText disabled
                                style="color: blue;"
                                [(ngModel)]="lblbannombre"
                                autocomplete="off">
                        </div>
                        <div class="p-col-1">
							<button (click)="aceptar()" pButton class="aceptar"
									style="line-height: 2.5em; font-family: Arial, serif; margin-top: -5px; height: 30px; width: 100px; ">
								Aceptar
							</button>
						</div>
                        <!--LINEA 2-->
                        <!-- <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
									<p-calendar id="ENCREGCOMPRO_FECHA"
										[inputStyle]="{width: '100%', height: '20px'}"
										[(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_FECHA"
										[readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()">
									</p-calendar>
								</div>
                                <div class="p-col-1">
                                    <span>Concepto:</span>
                                </div>
                                <div class="p-col-5">
									<label for="ENCREGCOMPRO_CONCEPTO"></label>
									<input class="frm" id="ENCREGCOMPRO_CONCEPTO" type="text" pInputText
										[(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_CONCEPTO"
										(keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
										autocomplete="off">
								</div>
                            </div>
                        </div> -->
                       
                    </div>
                </div>
            
            <app-aggridsaci 
            [width]=""
            [height]="70" 
            [enableSorting]="false" 
            [enableFilter]="true"
            [rowData]="cxcdetcomprobanteService.detregcomp" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsDetcomprobante"
            [defaultColDef]="defaultCxcdetcomp" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="true"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            [solobotoneliminar]="true"
            (selected)="seleccionItem($event)" 
            [tipodetalle]=""
            (cambios)="cambio($event)"
            [CC]="true">
            </app-aggridsaci>
            <!-- <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Comprobantes ya registrados en bancos o en registro de comprobantes</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                </div>
            </div> -->
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>
<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlgmae [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
						[where]="condicion"
						[busquedaParams]="busquedacampos"
						(opcionSeleccionada)="manejarSeleccion($event)"
						[busquedaCompuesta]="false"></app-busquedadlgmae>
</p-dialog>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusqueda"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
					 [where]="where"
					 [busquedaParams]="busquedacampos"
					 (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>